import { loginOpenId, openId, signupOpenId } from './types';

const basePath = ['openId', 'openId'];
const baseLoginPath = ['openId', 'login'];
const baseSignupPath = ['openId', 'signup'];

const marketplaceReducerObject = {
  [loginOpenId.request]: (state) =>
    state
      .setIn([...baseLoginPath, 'network', 'error'], false)
      .setIn([...baseLoginPath, 'network', 'loading'], true)
      .setIn([...baseLoginPath, 'network', 'success'], false),
  [loginOpenId.success]: (state) =>
    state
      .setIn([...baseLoginPath, 'network', 'loading'], false)
      .setIn([...baseLoginPath, 'network', 'error'], false)
      .setIn([...baseLoginPath, 'network', 'success'], true),
  [loginOpenId.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...baseLoginPath, 'network', 'loading'], false)
        .setIn([...baseLoginPath, 'network', 'error'], action.error)
        .setIn([...baseLoginPath, 'network', 'success'], false),
    ),
  [openId.request]: (state) =>
    state
      .setIn([...basePath, 'network', 'error'], false)
      .setIn([...basePath, 'network', 'loading'], true)
      .setIn([...basePath, 'network', 'success'], false)
      .setIn([...basePath, 'data'], null),
  [openId.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...basePath, 'network', 'loading'], false)
        .setIn([...basePath, 'network', 'error'], false)
        .setIn([...basePath, 'network', 'success'], true)
        .setIn([...basePath, 'data'], action.response),
    ),
  [openId.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...basePath, 'network', 'loading'], false)
        .setIn([...basePath, 'network', 'error'], true)
        .setIn([...basePath, 'network', 'success'], false),
    ),
  [signupOpenId.request]: (state) =>
    state
      .setIn([...baseSignupPath, 'network', 'error'], false)
      .setIn([...baseSignupPath, 'network', 'loading'], true)
      .setIn([...baseSignupPath, 'network', 'success'], false),
  [signupOpenId.success]: (state) =>
    state
      .setIn([...baseSignupPath, 'network', 'loading'], false)
      .setIn([...baseSignupPath, 'network', 'error'], false)
      .setIn([...baseSignupPath, 'network', 'success'], true),
  [signupOpenId.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...baseSignupPath, 'network', 'loading'], false)
        .setIn([...baseSignupPath, 'network', 'error'], action.error)
        .setIn([...baseSignupPath, 'network', 'success'], false),
    ),
};

export default marketplaceReducerObject;
